import { getStepIndexByKey } from './interviewSteps.utils';

export function buildInterviewUpdatePayload(existing, patch, steps) {
  const shouldUpdateStep = patch.action === 'approve' || patch.action === 'submit';

  const currentStepIndex = patch.currentRoundKey
    ? getStepIndexByKey(steps, patch.currentRoundKey)
    : existing.currentInterviewRound;

  const nextInterview =
    patch.action === 'approve' && patch.nextInterview
      ? new Date(patch.nextInterview).toISOString()
      : null;

  const nextStep = shouldUpdateStep ? currentStepIndex + 1 : currentStepIndex;

  const contract = patch.contract != null ? patch.contract : (existing.contract ?? []);

  const payload = {
    ...existing,
    ...patch,
    round1: { ...existing.round1, ...patch.round1 },
    round2: { ...existing.round2, ...patch.round2 },
    round3:
      patch.action === 'reject'
        ? existing.round3
        : [...(existing.round3 ?? []), ...(patch.round3 ?? [])],
    personalData: {
      ...existing.personalData,
      ...patch.personalData,
      documents: [
        ...(existing.personalData?.documents ?? []),
        ...(patch.personalData?.documents ?? []),
      ],
    },
    contract,
    induction: {
      ...existing.induction,
      ...patch.induction,
    },
    currentInterviewRound: nextStep,
    nextInterview,
  };

  return payload;
}
